// extracted by mini-css-extract-plugin
export default {"tag":"TagToggle_tag__Pd6+f","active":"TagToggle_active__6SbVQ","label":"TagToggle_label__RPR8Y","disabled":"TagToggle_disabled__5wa3W"};